import PatientsListViewSkeleton from "./PatinetListViewSkeleton";
import AddPatientPopUp from "../../../../components/GlobalHeader/components/AddPatientPopUp";
import PatientsListSearch from "./PatientsListSearch";
import PatientsListTable from "./PatientsListTable";
import PatientsBulkActionsBar from "./PatientsBulkActionsBar";
import PatientsListResultsBar from "./PatientsListResultsBar";
import MergePatientsModal from "./MergePatientsModal";
import { usePatientListviewData } from "@/lib/patient/patientListviewData";
import {
  setShowPermissionMessage,
  setShowPermissionModal,
} from "@/dispatchers/appDispatchers";

function PatientListView() {
  const {
    darkMode,
    currentPharmacyId,
    patientListLoader,
    patientsFilter,
    assigneeFilter,
    consultationStatusFilter,
    showDuplicatesOnly,
    duplicatePatientIds,
    selectedPatients,
    sortField,
    sortDirection,
    mergePair,
    showMergeModal,
    patientForm,
    loadingRowId,
    mergePatientDetailsLoader,
    patientConsultationCountLoading,
    showWarningDialog,
    treatmentPlanFilter,
    searchTitanEnabled,
    includeTitanPatients,

    assignees,
    filteredPatients,
    selectAll,

    setPatientsFilter,
    setAssigneeFilter,
    setConsultationStatusFilter,
    setShowDuplicatesOnly,
    setShowMergeModal,
    setShowWarningDialog,
    setSearchTitanEnabled,
    setTreatmentPlanFilter,
    setIncludeTitanPatients,
    setTriggerTitanSearch,

    onPatientClick,
    onConsultationClick,
    handleAddPatient,
    handleSelectAll,
    handleSelectPatient,
    handleSort,
    handleMerge,
    handleClearSelection,
    handleMergePatientsClick,
    openPatientForm,
    onImportFromTitan,
    isImportMultipleFromTitanLoading,
    handleSearchTitanEnabledChange,
    handleSearch,
  } = usePatientListviewData();

  return (
    <>
      {patientListLoader ? (
        <PatientsListViewSkeleton darkMode={darkMode} />
      ) : (
        <div className={darkMode ? "pl-container dark" : "pl-container light"}>
          <PatientsListSearch
            isDarkMode={darkMode}
            searchValue={patientsFilter}
            onSearchChange={setPatientsFilter}
            assigneeFilter={assigneeFilter}
            onAssigneeFilterChange={setAssigneeFilter}
            assignees={assignees}
            consultationStatusFilter={consultationStatusFilter}
            onConsultationStatusFilterChange={setConsultationStatusFilter}
            treatmentPlanFilter={treatmentPlanFilter}
            onTreatmentPlanFilterChange={setTreatmentPlanFilter}
            showDuplicatesOnly={showDuplicatesOnly}
            onShowDuplicatesOnlyChange={setShowDuplicatesOnly}
            duplicateCount={duplicatePatientIds.size}
            // viewMode={viewMode}
            // onViewModeChange={setViewMode}
            searchTitanEnabled={searchTitanEnabled}
            onSearchTitanEnabledChange={handleSearchTitanEnabledChange}
            handleSearch={handleSearch}
          />

          {/* Results bar - shows Expand to Titan when results exist */}
          <PatientsListResultsBar
            isDarkMode={darkMode}
            searchValue={patientsFilter}
            includeTitanPatients={includeTitanPatients}
            onIncludeTitanPatientsChange={setIncludeTitanPatients}
            hasResults={filteredPatients.length > 0}
            searchTitanEnabled={searchTitanEnabled}
          />

          <PatientsListTable
            patients={filteredPatients}
            isDarkMode={darkMode}
            currentPharmacyId={currentPharmacyId}
            onPatientClick={onPatientClick}
            onConsultationClick={onConsultationClick}
            onAddPatient={handleAddPatient}
            selectAll={selectAll}
            onSelectAll={handleSelectAll}
            selectedPatients={selectedPatients}
            onSelectPatient={handleSelectPatient}
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={handleSort}
            searchValue={patientsFilter}
            includeTitanPatients={includeTitanPatients}
            onIncludeTitanPatientsChange={handleSearchTitanEnabledChange}
            searchTitanEnabled={searchTitanEnabled}
            setTriggerTitanSearch={setTriggerTitanSearch}
            setShowPermissionMessage={setShowPermissionMessage}
            setShowPermissionModal={setShowPermissionModal}
          />

          <PatientsBulkActionsBar
            isDarkMode={darkMode}
            count={selectedPatients.size}
            onMerge={handleMerge}
            onClear={handleClearSelection}
            selectedPatients={selectedPatients}
            patients={filteredPatients}
            onImport={onImportFromTitan}
            isImporting={isImportMultipleFromTitanLoading}
          />

          {mergePair && (
            <MergePatientsModal
              open={showMergeModal}
              onOpenChange={(open) => setShowMergeModal(open)}
              patientA={mergePair[0]}
              patientB={mergePair[1]}
              isDarkMode={darkMode}
              onConfirm={handleMergePatientsClick}
              mergePatientDetailsLoader={mergePatientDetailsLoader}
              patientConsultationCountLoading={patientConsultationCountLoading}
              showWarningDialog={showWarningDialog}
              setShowWarningDialog={setShowWarningDialog}
            />
          )}

          {patientForm && (
            <AddPatientPopUp
              open={patientForm}
              onOpenChange={openPatientForm}
              onSave={(patient) => {}}
              isDarkMode={darkMode}
            />
          )}
        </div>
      )}
    </>
  );
}

export default PatientListView;
